<div class="card flex justify-content-center">
  <div class="p-scroller-header">
    <h3 class="h4 text-start">User profile history</h3>
  </div>
  <p-scroller #sc [items]="historyItemsDisplaying"
              [itemSize]="100"
              [showLoader]="true"
              [delay]="250"
              [loading]="lazyLoading"
              [lazy]="true"
              (onLazyLoad)="onLazyLoad($event)"
              styleClass="border-1 surface-border"
              [style]="{'height': '200px'}">
    <ng-template let-historyItem pTemplate="item">
      <dl class="m-2 border-bottom border-medium">
        <dt *ngIf="historyItem.UserTypeId">User Type: {{historyItem.UserTypeId || ''}}<ng-container *ngIf="historyItem.RoleId"> | Job Title: {{historyItem.JobTitleId || ''}}{{ !!historyItem.OtherJobTitle ? (': ' + historyItem.OtherJobTitle) : ''}} | User Role: {{ historyItem.RoleId || ''}}</ng-container><ng-container *ngIf="historyItem.UserTypeId != 'ATF HQ'">{{ !!historyItem.FieldDivisionId ? ' | Field Division: ' + (historyItem.FieldDivisionId || '') + ' | FD Group: ' + (historyItem.FDGroupId || '') : ' | Agency Name: ' + (historyItem.AgencyId || '')}}</ng-container></dt>
        <dd>{{ historyItem.Comments }}</dd>
      </dl>
    </ng-template>
  </p-scroller>
  </div>
